/**
 * Clave de caché de TanStack Query del plan de cuotas (FEAT-105-7).
 *
 * `document-installments`: cuotas del documento que la grilla renderiza. Se
 * invalida tras editar/regenerar para mantener la cabecera/totales consistentes.
 */
export const installmentsQueryKey = (documentId: string) =>
  ['document-installments', documentId] as const;
